// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"1490507c","305":"e1e255fb","422":"f7081260","488":"5cdbb697","492":"e516cd46","680":"0040dc83","721":"27ea2417","880":"d79f9b0d","889":"e6592bc3","892":"0dec71c2","962":"a36a86b0"}[chunkId] + ".chunk.js";
};